import React from 'react';
import { BadgeCheck } from 'lucide-react';

/**
 * Verified Wholesaler badge.
 * size: 'sm' | 'md' | 'lg'
 * showLabel: whether to include the "Verified" text
 */
export default function VerifiedBadge({ size = 'sm', showLabel = true, className = '' }) {
  const sizes = {
    sm: { icon: 'h-3.5 w-3.5', text: 'text-xs', pad: 'px-2 py-0.5' },
    md: { icon: 'h-4 w-4', text: 'text-sm', pad: 'px-2.5 py-1' },
    lg: { icon: 'h-5 w-5', text: 'text-base', pad: 'px-3 py-1' },
  };
  const s = sizes[size] || sizes.sm;
  return (
    <span
      title="Verified wholesaler — has posted 3+ deals with no reports"
      className={`inline-flex items-center gap-1 rounded-full bg-blue-50 text-blue-700 font-medium border border-blue-200 ${s.text} ${s.pad} ${className}`}
      data-testid="verified-badge"
    >
      <BadgeCheck className={s.icon} />
      {showLabel && <span>Verified</span>}
    </span>
  );
}
